import { FiltersTypeEnum, IFilterComboComponent, IFilterTextComponent } from 'world-archery-lib';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, combineLatest } from 'rxjs';
import { mergeMap, tap, map, filter } from 'rxjs/operators';
import * as op from 'rxjs/operators';
import { environment } from '@environments/environment';
import { ActivatedRoute } from '@angular/router';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@angular/router";
export class PrizeForPrecisionService {
    constructor(http, route) {
        this.http = http;
        this.route = route;
        this.filtersType = [
            {
                options: {
                    type: FiltersTypeEnum.TextSearch,
                    intercept_name: 'search',
                    id: 'prizeforprecisiontextfilter',
                    defaultTextValue: '',
                    text_subject: new BehaviorSubject('')
                }
            },
            {
                options: {
                    type: FiltersTypeEnum.ComboBox,
                    intercept_name: 'year',
                    initial_state: true,
                    name_filter: 'Year',
                    options_subject: new BehaviorSubject([]),
                    option_name_property: 'Year',
                    options_selected_subject: new BehaviorSubject({}),
                    id: 'prizeforprecisionyear'
                }
            },
            {
                options: {
                    type: FiltersTypeEnum.ComboBox,
                    intercept_name: 'category',
                    name_filter: 'Categories',
                    options_subject: new BehaviorSubject([]),
                    option_name_property: 'CatName',
                    options_selected_subject: new BehaviorSubject({}),
                    id: 'prizeforprecisiondiscipline'
                }
            }
        ];
        this.country = [];
        this.sort = {
            asc: true, category: 'RANKING'
        };
        this.categoriesSubject = new BehaviorSubject(undefined);
        this.changeSubject = new BehaviorSubject(this.sort);
        this.http.get(environment.api_url, { params: new HttpParams({ fromObject: { content: 'COUNTRIES', v: String(3), RBP: 'ALL' } }) })
            .subscribe(next => this.country = next.items);
        this.http.get(environment.api_url, { params: new HttpParams({ fromObject: { content: environment.priceForPrecision.apiYearData, RBP: 'ALL', v: String(3) } }) })
            .pipe(map(a => a.items.filter(value => value.PrecisionPrize === true)), tap(a => {
            let selected = a[0];
            if (this.route.snapshot.queryParams['year']) {
                const indexYear = a.findIndex(value => value.Year.toString() === this.route.snapshot.queryParams['year']);
                if (indexYear > -1) {
                    selected = a[indexYear];
                }
            }
            this.filtersType[1].options.options_selected_subject.next(selected);
            this.filtersType[1].options.options_subject.next(a);
        })).subscribe();
        this.filtersType[1].options
            .options_selected_subject.asObservable()
            .pipe(filter(a => a !== undefined), mergeMap(a => {
            return this.http.get(environment.api_url, { params: new HttpParams({ fromObject: { v: String(3), content: environment.priceForPrecision.apiContentCategories, Year: a.Year, RBP: 'ALL' } }) })
                .pipe(tap(data => {
                const arr = data.items.filter(value => value.seasonPrize === true);
                this.categoriesSubject.next(data);
                this.filtersType[2].options.options_subject.next(arr);
            }));
        })).subscribe();
    }
    generateDefaultValues() {
        return combineLatest(this.filtersType[0].options.text_subject.asObservable().pipe(op.debounceTime(300)), this.filtersType[1].options.options_selected_subject.asObservable(), this.filtersType[2].options.options_selected_subject.asObservable(), this.changeSubject.asObservable()).pipe(map(([text, year, category, sort]) => {
            return { text: text, year: year ? year.Year : undefined, catCode: category ? category.Cat : undefined, sort: sort, wCupStage: category ? category.WCupStage : undefined };
        }), filter(a => a.catCode !== undefined && a.year !== undefined));
    }
    modifyOrderValue(next) {
        this.changeSubject.next(next);
    }
}
PrizeForPrecisionService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PrizeForPrecisionService_Factory() { return new PrizeForPrecisionService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ActivatedRoute)); }, token: PrizeForPrecisionService, providedIn: "root" });
